// Suporte ao ESC que fecha a conversa aberta (igual WhatsApp Web).
//
// O ESC é "em camadas": se tem algo aberto por cima da conversa, ele fecha essa
// coisa primeiro; só quando não sobra nada é que a conversa fecha. Aqui ficam as
// duas peças que sustentam isso:
//
// 1. `temOverlayAberto()` — overlays de biblioteca (Dialog/Menu/Popover/
//    Autocomplete/lightbox). Modal do MUI já dá `stopPropagation()` no ESC, então
//    na prática o evento nem chega no listener da página (que escuta no `window`,
//    depois do `document` onde o React 16 delega). O check de DOM é o cinto de
//    segurança pros casos em que não há stopPropagation: `disableEscapeKeyDown`
//    e o lightbox do react-modal-image (listener próprio no document, sem parar
//    a propagação).
//
// 2. `registrarConsumidorEsc()` — camadas de estado React que só o componente
//    conhece (gravação de áudio em curso, emoji picker, popup de estoque, anexos
//    na pré-visualização, resposta citada...). Cada consumidor devolve `true`
//    quando "gastou" o ESC; a conversa só fecha se todos devolverem false.
//
// O último registrado é consultado primeiro (pilha), então componentes mais
// internos ganham do mais externo.

const SELETORES_OVERLAY = [
	".MuiDialog-root", // Dialog v4
	".MuiPopover-root", // Popover e Menu v4
	".MuiModal-root", // Dialog/Menu/Popover/Drawer temporário v5
	".MuiAutocomplete-popper", // dropdown do Autocomplete (v4 lab e v5)
	".__react_modal_image__modal_container", // lightbox de imagem
];

// Menu com `keepMounted` (ex.: TicketOptionsMenu) deixa o root no DOM mesmo
// fechado — o MUI só troca a visibility. Sem esse filtro o ESC ficaria
// permanentemente "engolido" por um menu fechado.
const estaVisivel = el => {
	const estilo = window.getComputedStyle(el);
	return estilo.display !== "none" && estilo.visibility !== "hidden";
};

export const temOverlayAberto = () =>
	SELETORES_OVERLAY.some(seletor =>
		Array.from(document.querySelectorAll(seletor)).some(estaVisivel)
	);

const consumidores = [];

// Devolve a função de baixa — usar direto como cleanup do useEffect.
export const registrarConsumidorEsc = handler => {
	consumidores.push(handler);
	return () => {
		const i = consumidores.indexOf(handler);
		if (i >= 0) consumidores.splice(i, 1);
	};
};

export const consumirEsc = event => {
	for (let i = consumidores.length - 1; i >= 0; i--) {
		try {
			if (consumidores[i](event) === true) return true;
		} catch (err) {
			// Consumidor com erro não pode travar o ESC da conversa.
			console.error("Erro em consumidor de ESC:", err);
		}
	}
	return false;
};
